export { AgileShareUpNext, type AgileShareUpNextProps } from "./share-up-next";
export { AgileShareUpNext as default } from "./share-up-next";
